module.exports = __webpack_public_path__ + "static/media/A (1).744b623b.jpg";